class stateUtils {
  dateYYYYMMDD = (date) => {
    let d = date;
    if (d instanceof Date) {
      if (Number.isNaN(d.getTime())) {
        d = new Date();
      }
    } else if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}/.test(d)) {
      return d.slice(0, 10);
    } else {
      d = new Date(d);
      if (Number.isNaN(d.getTime())) {
        d = new Date();
      }
    }
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0",
    )}-${String(d.getDate()).padStart(2, "0")}`;
  };

  dateYYYYMMDDPoint = (date) => {};
}
export default new stateUtils();
